/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../../components/UI'
import React, {FC, useEffect, useState} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {updateReserveGuestBed} from '../../../../services/booking.service'
import {BedBookingModel, BedsBookingDto} from '../../../../models/booking.model'
import {SnackbarProvider, enqueueSnackbar} from 'notistack'
import Swal from 'sweetalert2'
import {ModalAddProduct} from '../Modal/ModalAddProduct'
import {
  getListReservaCamaProductoTipoHuesped,
  deleteReserveBedProductTypeGuestService,
} from '../../../../services/checking.service'
import {ReservaCamaProductoTipoHuespedModel} from '../../../../models/ckecking.model'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
import {getSnackBarToast} from '../../../../../../util/snackBar'

const TableChekinProducts: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination, selected} = useKTable()
  const {currentTabItem, isAllowed} = useHoteleria()
  const [showModalAddProduct, setShowModalAddProduct] = useState(false)

  const getProductsCheckin = async () => {
    try {
      setLoading(true)
      const {data: response} = await getListReservaCamaProductoTipoHuesped({
        ReservaCamaId: currentTabItem.idToEdit as string,
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
      })
      if (!response.error) {
        const productsData = (response.data as any)?.productosAplicacion ?? response.data ?? []
        setData(productsData)
        setPagination({
          ...pagination,
          totalResults: response.total ?? productsData.length ?? 0,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const getSnackBarNoExit = (message: string) => {
    enqueueSnackbar(message, {
      variant: 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    })
  }
  const getSnackBarExit = (message: string) => {
    enqueueSnackbar(message, {
      variant: 'success',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    })
  }

  const style = {
    container: (base: any) => ({
      ...base,
      width: '100%',
    }),
    menu: (base: any) => ({
      ...base,
      zIndex: 9999,
      position: 'relative',
      top: 0,
      left: 0,
    }),
    control: (base: any) => ({
      ...base,
      borderColor: '#e2ebf6',
    }),
  }

  const handleChangeGuest = async (guest: any, reserve: BedBookingModel) => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: `Asignaras el huésped ${guest.label} a la reserva`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, asignar',
      confirmButtonColor: 'var(--kt-primary)',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true)
        try {
          let dtoReserveGuest: BedsBookingDto = {
            ReservaId: reserve.ReservaId,
            CamaId: reserve.CamaId,
            HuespedId: guest.value,
          }
          const data = await updateReserveGuestBed(dtoReserveGuest)
          if (!data.data.error) {
            getProductsCheckin()
            getSnackBarToast('Se asigno con éxito', 'success')
          } else {
            getSnackBarToast(data.data.message, 'error')
          }
          setLoading(false)
        } catch (error) {
          setLoading(false)
          getSnackBarToast('Error interno', 'error')
        }

        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        const mappedSelected = selected.map((item) => ({Id: item}))
        const {data: response} = await deleteReserveBedProductTypeGuestService(mappedSelected)
        if (!response.error) {
          getSnackBarToast('Se ha eliminado con éxito', 'success')
          getProductsCheckin()
        } else {
          getSnackBarToast(response.message, 'error')
        }
        getProductsCheckin()
        Swal.close()
      }
    })
  }

  useEffect(() => {
    getProductsCheckin()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit, pagination.currentPage])

  const columns: Column<ReservaCamaProductoTipoHuespedModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => {
        return <KTableSelectionCell id={props.data[props.row.index].Id} />
      },
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo Huésped' />,
      accessor: 'TipoHuesped_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Producto' />,
      accessor: 'Producto_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cantidad' />,
      accessor: 'Cantidad',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Observaciones' />,
      accessor: 'Observaciones',
    },
  ]

  const handleShowModal = () => {
    setShowModalAddProduct(true)
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          {isAllowed('PRODUCTOS/AGREGAR') && (
            <button type='button' className='btn btn-success btn-sm me-3' onClick={handleShowModal}>
              Agregar Producto
            </button>
          )}
          {isAllowed('PRODUCTOS/ELIMINAR') && (
            <button
              type='button'
              className='btn btn-danger btn-sm me-3'
              onClick={handleDelete}
              disabled={Boolean(!selected.length)}
            >
              Eliminar Producto
            </button>
          )}
        </div>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <ModalAddProduct
          show={showModalAddProduct}
          setShow={setShowModalAddProduct}
          getProductsCheckin={getProductsCheckin}
        />
      </KTCard>
    </>
  )
}

const TableChekinProductsWrapper = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useHoteleria()
  const handleBack = () => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false

  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}

        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            {isAllowed('PRODUCTOS/ACCESO') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Productos de la reserva</Tab>
            )}
          </TabList>
          {isAllowed('PRODUCTOS/ACCESO') && (
            <TabPanel>{isAllowed('PRODUCTOS/LISTAR') && <TableChekinProducts />}</TabPanel>
          )}
        </Tabs>
      </div>
      <SnackbarProvider />
    </KTableProvider>
  )
}

export {TableChekinProductsWrapper}
